import { ContentNotificationComponent } from '@shared/components/content-notification/content-notification.component';
import { DepositDelayInfoComponent } from '@shared/components/deposit-delay-info/deposit-delay-info.component';
import { DialogIbanReminderComponent } from '@shared/components/dialog-iban-reminder/dialog-iban-reminder.component';
import { DialogPortfolioSpinnerComponent } from '@shared/components/dialog-portfolio-spinner/dialog-portfolio-spinner.component';
import { DialogPortfolioWarningComponent } from '@shared/components/dialog-portfolio-warning/dialog-portfolio-warning.component';

import { App3aFooterComponent } from './3a-footer/app-3a-footer.component';
import { AppAccountOpeningBlockerComponent } from './account-opening-blocker/account-opening-blocker.component';
import { AOTransparencyToggleComponent } from './ao-transparency-toggle/ao-transparency-toggle.component';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { DateOfBirthComponent } from './date-of-birth/date-of-birth.component';
import { DialogBookConsultationComponent } from './dialog-book-consultation/dialog-book-consultation.component';
import { DialogDiscardedWishesComponent } from './dialog-discarded-wishes/dialog-discarded-wishes.component';
import { DialogEve2ExplanationComponent } from './dialog-eve2-explanation/dialog-eve2-explanation.component';
import { DialogGeneratingSpinnerComponent } from './dialog-generating-spinner/dialog-generating-spinner.component';
import { DialogPromotionsComponent } from './dialog-promotions/dialog-promotions.component';
import { DialogReminderComponent } from './dialog-reminder/dialog-reminder.component';
import { DialogStabilityComponent } from './dialog-stability/dialog-stability.component';
import { DialogTreePlantedComponent } from './dialog-tree-planted/dialog-tree-planted.component';
import { EditingStrategyComponent } from './editing-strategy/editing-strategy.component';
import { GreenSurveyComponent } from './green-survey/green-survey.component';
import { GuaranteeComponent } from './guarantee/guarantee.component';
import { GuaranteeShieldComponent } from './guarantee-shield/guarantee-shield.component';
import { AppLoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { MinFundBoxComponent } from './min-fund-box/min-fund-box.component';
import { MobilePromoComponent } from './mobile-promo/mobile-promo.component';
import { NavbarDesktopComponent } from './navbar/navbar-desktop.component';
import { NavbarMobileComponent } from './navbar/navbar-mobile.component';
import { NavbarComponent } from './navbar/navbar.component';
import { NotificationSuccessComponent } from './notification-success/notification-success.component';
import { PaginationComponent } from './pagination/pagination.component';
import { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
import { PromoBannerComponent } from './promo-banner/promo-banner.component';
import { PromoCampaignComponent } from './promo-campaign/promo-campaign.component';
import { RegisterPasswordStrengthComponent } from './register-password-strength/register-password-strength.component';
import { RemainingTimeLabelComponent } from './remaining-time-label/remaining-time-label.component';
import { RiskRecheckBoxComponent } from './risk-recheck-box/risk-recheck-box.component';
import { SavingsAnalysisComponent } from './savings-analysis/savings-analysis.component';
import { SavingsAnalysis3aComponent } from './savings-analysis-3a/savings-analysis-3a.component';
import { SavingsChartTooltipComponent } from './savings-chart-tooltip/savings-chart-tooltip.component';
import { SavingsDepositComponent } from './savings-deposit/savings-deposit.component';
import { SavingsDeposit3aComponent } from './savings-deposit-3a/savings-deposit-3a.component';
import { SavingsSumUpComponent } from './savings-sum-up/savings-sum-up.component';
import { SocialProofComponent } from './social-proof/social-proof.component';
import { SuperHumanSurveyBoxComponent } from './super-human-survey-box/super-human-survey-box.component';
import { SwissMadeFooterComponent } from './swiss-made-footer/swiss-made-footer.component';
import { ToastNotificationsComponent } from './toast-notifications/toast-notifications.component';
import { ToastNotificationsProgressComponent } from './toast-notifications-progress/toast-notifications-progress.component';
import { Transfer3AAccountComponent } from './transfer-3A-account/transfer-3A-account';
import { VerificationDocumentsComponent } from './verification-documents/verification-documents.component';

export const components = [
  AOTransparencyToggleComponent,
  App3aFooterComponent,
  AppAccountOpeningBlockerComponent,
  AppFooterComponent,
  AppLoadingSpinnerComponent,
  SavingsDepositComponent,
  SavingsDeposit3aComponent,
  DateOfBirthComponent,
  DialogBookConsultationComponent,
  DialogDiscardedWishesComponent,
  DialogEve2ExplanationComponent,
  DialogGeneratingSpinnerComponent,
  DialogPortfolioSpinnerComponent,
  DialogPortfolioWarningComponent,
  DialogPromotionsComponent,
  DialogReminderComponent,
  DialogStabilityComponent,
  DialogTreePlantedComponent,
  EditingStrategyComponent,
  GuaranteeComponent,
  GuaranteeShieldComponent,
  MobilePromoComponent,
  NavbarComponent,
  NavbarDesktopComponent,
  NavbarMobileComponent,
  NotificationSuccessComponent,
  PaginationComponent,
  PhoneVerificationComponent,
  SavingsAnalysisComponent,
  SavingsAnalysis3aComponent,
  SavingsChartTooltipComponent,
  SavingsSumUpComponent,
  RegisterPasswordStrengthComponent,
  RemainingTimeLabelComponent,
  RiskRecheckBoxComponent,
  MinFundBoxComponent,
  SocialProofComponent,
  SuperHumanSurveyBoxComponent,
  SwissMadeFooterComponent,
  ToastNotificationsComponent,
  ToastNotificationsProgressComponent,
  Transfer3AAccountComponent,
  VerificationDocumentsComponent,
  DialogIbanReminderComponent,
  ContentNotificationComponent,
  DepositDelayInfoComponent,
  PromoBannerComponent,
  PromoCampaignComponent,
  GreenSurveyComponent
];

export { ContentNotificationComponent } from '@shared/components/content-notification/content-notification.component';
export { DepositDelayInfoComponent } from '@shared/components/deposit-delay-info/deposit-delay-info.component';
export { DialogIbanReminderComponent } from '@shared/components/dialog-iban-reminder/dialog-iban-reminder.component';
export { DialogPortfolioSpinnerComponent } from '@shared/components/dialog-portfolio-spinner/dialog-portfolio-spinner.component';
export { DialogPortfolioWarningComponent } from '@shared/components/dialog-portfolio-warning/dialog-portfolio-warning.component';
export { App3aFooterComponent } from './3a-footer/app-3a-footer.component';
export { AOTransparencyToggleComponent } from './ao-transparency-toggle/ao-transparency-toggle.component';
export { AppFooterComponent } from './app-footer/app-footer.component';
export { AppAccountOpeningBlockerComponent } from './account-opening-blocker/account-opening-blocker.component';
export { DateOfBirthComponent } from './date-of-birth/date-of-birth.component';
export { DialogBookConsultationComponent } from './dialog-book-consultation/dialog-book-consultation.component';
export { DialogDiscardedWishesComponent } from './dialog-discarded-wishes/dialog-discarded-wishes.component';
export { DialogEve2ExplanationComponent } from './dialog-eve2-explanation/dialog-eve2-explanation.component';
export { DialogGeneratingSpinnerComponent } from './dialog-generating-spinner/dialog-generating-spinner.component';
export { DialogPromotionsComponent } from './dialog-promotions/dialog-promotions.component';
export { DialogReminderComponent } from './dialog-reminder/dialog-reminder.component';
export { DialogStabilityComponent } from './dialog-stability/dialog-stability.component';
export { DialogTreePlantedComponent } from './dialog-tree-planted/dialog-tree-planted.component';
export { EditingStrategyComponent } from './editing-strategy/editing-strategy.component';
export { GreenSurveyComponent } from './green-survey/green-survey.component';
export { GuaranteeShieldComponent } from './guarantee-shield/guarantee-shield.component';
export { GuaranteeComponent } from './guarantee/guarantee.component';
export { MinFundBoxComponent } from './min-fund-box/min-fund-box.component';
export { MobilePromoComponent } from './mobile-promo/mobile-promo.component';
export { NavbarDesktopComponent } from './navbar/navbar-desktop.component';
export { NavbarMobileComponent } from './navbar/navbar-mobile.component';
export { NavbarComponent } from './navbar/navbar.component';
export { NotificationSuccessComponent } from './notification-success/notification-success.component';
export { PaginationComponent } from './pagination/pagination.component';
export { PhoneVerificationComponent } from './phone-verification/phone-verification.component';
export { PromoBannerComponent } from './promo-banner/promo-banner.component';
export { PromoCampaignComponent } from './promo-campaign/promo-campaign.component';
export { RegisterPasswordStrengthComponent } from './register-password-strength/register-password-strength.component';
export { RemainingTimeLabelComponent } from './remaining-time-label/remaining-time-label.component';
export { RiskRecheckBoxComponent } from './risk-recheck-box/risk-recheck-box.component';
export { SavingsAnalysis3aComponent } from './savings-analysis-3a/savings-analysis-3a.component';
export { SavingsAnalysisComponent } from './savings-analysis/savings-analysis.component';
export { SavingsChartTooltipComponent } from './savings-chart-tooltip/savings-chart-tooltip.component';
export { SavingsDeposit3aComponent } from './savings-deposit-3a/savings-deposit-3a.component';
export { SavingsDepositComponent } from './savings-deposit/savings-deposit.component';
export { SavingsSumUpComponent } from './savings-sum-up/savings-sum-up.component';
export { SocialProofComponent } from './social-proof/social-proof.component';
export { SuperHumanSurveyBoxComponent } from './super-human-survey-box/super-human-survey-box.component';
export { SwissMadeFooterComponent } from './swiss-made-footer/swiss-made-footer.component';
export { ToastNotificationsComponent } from './toast-notifications/toast-notifications.component';
export { ToastNotificationsProgressComponent } from './toast-notifications-progress/toast-notifications-progress.component';
export { Transfer3AAccountComponent } from './transfer-3A-account/transfer-3A-account';
export { VerificationDocumentsComponent } from './verification-documents/verification-documents.component';
